import angular from 'angular';

class MetaTagService {

    constructor() {
        this.defaultTags = {};
        this.tagElements = [];
    }

    setDefaultTags(tags) {
        angular.copy(tags, this.defaultTags);
        this.setTags({});
    }

    setTags(tags) {
        this.tags={
          // General SEO
          'keywords': tags.keywords,
          'title': tags.title,
          'author': __env.author,
          'description': tags.meta_description,
          //Open Graph
          'og:title': tags.og_title,
          'og:description': tags.og_description,
          'og:image': __env.frontPath+tags.url_imagen,
          'og:url': __env.frontPath+tags.slug,
        }
        this.clearTags();
        this.mergeDefaultTags(this.tags);
        angular.forEach(this.tags, (content, name) => {
          let tagElement = this.getTagElement(content, name);
          document.head.appendChild(tagElement);
          this.tagElements.push(tagElement);
        });


    }

    mergeDefaultTags(tags) {
        angular.forEach(this.defaultTags, (defaultTagContent, defaultTagName) => {
            if (!tags[defaultTagName]) {
                tags[defaultTagName] = defaultTagContent;
            } else if (defaultTagName === 'title') {
                tags['title'] += ' - ' + defaultTagContent;
            }
        });
        return tags;
    }

    getTagElement(content, name) {
        if (name == 'title') {
            // Special provision for the title element
            var title = document.createElement('title');
            title.textContent = content;
            return title;
        } else {
            // Opengraph uses [property], but everything else uses [name]
            var nameAttr = (name.indexOf('og:') === 0) ? 'property' : 'name';
            var meta = document.createElement('meta');
            meta.setAttribute(nameAttr, name);
            meta.setAttribute('content', content);
            return meta;
        }
    }

    clearTags() {
        angular.forEach(this.tagElements, (tagElement) => {
            document.head.removeChild(tagElement);
        });
        this.tagElements.length = 0;
    }
}

MetaTagService.$inject = [];

let metatagModule = angular.module('metatag', [])
    .service('MetatagService', MetaTagService);

export default metatagModule;



// WEBPACK FOOTER //
// ./www/components/metatag.service.js